module.exports = __webpack_public_path__ + "img/bg-vip-all.2b41c32f.png";